import {
  ApiRequest,
  GetBaseServiceFunctions,
  queryClient,
} from '../baseService'

const BaseRoute = 'app/report-corrections'

const baseFunctions = GetBaseServiceFunctions(BaseRoute)

function UpdateNote(id, data) {
  return ApiRequest.put(`${BaseRoute}/${id}/note`, data)
}

function UpdateStatus(id, data) {
  return ApiRequest.put(`${BaseRoute}/${id}/status`, data)
}

// ===== Reports QA Sheet redesign (FE-01) =====
function UpdateCorrectionsStatus(id, data) {
  return ApiRequest.put(`${BaseRoute}/${id}/corrections-status`, data)
}

function UpdateAmendmentStatus(id, data) {
  return ApiRequest.put(`${BaseRoute}/${id}/amendment-status`, data)
}

function UpdateDelays(id, data) {
  return ApiRequest.put(`${BaseRoute}/${id}/delays`, data)
}

// ===== Reports QA Sheet redesign — round 2 (FE-12..15) =====
function UpdateAssignee(id, data) {
  return ApiRequest.put(`${BaseRoute}/${id}/assignee`, data)
}

function GetStatusHistory(id, params = {}) {
  return ApiRequest.get(`${BaseRoute}/${id}/status-history`, { params })
}
// =============================================
// =============================================

function ExportSearchResult(payload = {}) {
  return ApiRequest.post(`${BaseRoute}/export`, payload, {
    responseType: 'arraybuffer',
  })
}

const API = {
  ...baseFunctions,
  UpdateNote,
  UpdateStatus,
  UpdateCorrectionsStatus,
  UpdateAmendmentStatus,
  UpdateDelays,
  UpdateAssignee,
  GetStatusHistory,
  ExportSearchResult,
}

export default API
